import { Button } from '../../components/Button/NewButton';
import { Warning } from '@material-ui/icons';
import { useCreateOperator } from '../../contexts/CreateOperatorContext';

export const Footer = () => {
  const { operator } = useCreateOperator();
  const classes = useStyles();

  const validateOperator = () => {
    const validOperatorId = operator.id.toString().length === 6;
    const validOperatorCode =
      operator.code.trim().length >= 4 && operator.code.trim().length <= 6;
    const hasMediaroom = Boolean(operator.mediaRoomSettings);
    const hasMediaFirst = Boolean(operator.mediaFirstSettings);
    const mediaroomRequirements =
      (operator.mediaRoomSettings?.branch ?? '').trim() !== '';
    const mediaFirstRequirements =
      (operator.mediaFirstSettings?.tenantId ?? '').trim() !== '';
    const baseRequirements =
      validOperatorId &&
      operator.name.trim() !== '' &&
      validOperatorCode &&
      operator.timeZone.trim() !== '';

    if (hasMediaroom && hasMediaFirst)
      return (
        baseRequirements && mediaroomRequirements && mediaFirstRequirements
      );
    else if (hasMediaroom && hasMediaFirst === false)
      return baseRequirements && mediaroomRequirements;
    else if (hasMediaFirst && hasMediaroom === false)
      return baseRequirements && mediaFirstRequirements;
    else return false;
  };

  return (
    <div className={classes.container}>
      <p>
        <span className="text-amber-200 mr-4">
          <Warning fontSize="small" />
        </span>
        New Operators cannot be deleted once created
      </p>
      <Button disabled={validateOperator() == false} width={200} type="submit">
        Create
      </Button>
    </div>
  );
};

const useStyles = () => ({
  container:
    'sticky bottom-0 z-20 bg-background-light dark:bg-background-dark inline-flex items-center justify-between gap-2 p-4 w-full mt-auto border-t border-border-light dark:border-border-dark',
});
